import script from "./JobCallsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobCallsModal.vue?vue&type=script&setup=true&lang=ts"

import "./JobCallsModal.vue?vue&type=style&index=0&id=e3736cce&scoped=true&lang=css"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3736cce"]])

export default __exports__